exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".studio-input-bar-send-tips{min-width:auto;padding:10px}", ""]);

// exports
